import React from "react";
import { Field } from "formik";
import { Grid, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, FormHelperText, Container, Box, Divider, Typography, Button } from "@mui/material";
import SignatureField from './SignatureField';
import { Label } from "@mui/icons-material";


// Define the initial form values
export const initialValues = {
    applicationDate: new Date(Date.now()).toLocaleDateString(),
    arrestDate: "",
    offenseDate: "",
    caseNumber: "",
    courtDate: "",
    SID: "",
    judge: "",
    attorney: "",
    lastName: "",
    firstName: "",
    middleName: "",
    charge1: "",
    warrant1: "",
    charge2: "",
    warrant2: "",
    charge3: "",
    warrant3: "",
    charge4: "",
    warrant4: "",
    charge5: "",
    warrant5: "",
    codefendants: "",
    dob: "",
    race: "",
    sex: "",
    preferredPronouns: "",
    veteran: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    cellPhone: "",
    email: "",
    emergencyContactName: "",
    emergencyContactPhone: "",
    emergencyContactAddress: "",
    maritalStatus: "",
    spouseName: "",
    spouseEmployment: "",
    spouseEmploymentInformation: "",
    spouseIncome: "",
    spouseIncomeFrequency: "",
    ageOfChildren: "",
    otherDependents: "",
    employment: "",
    employerName: "",
    employerAddress: "",
    employerTelephone: "",
    jobTitle: "",
    lengthOfEmployment: "",
    mostRecentEmployment: "",
    income: "",
    incomeFrequency: "",
    courtOrderedChildSupport: "",
    courtOrderedChildSupportFrequency: "",
    receiveChildSupport: "",
    receivedAmountChildSupport: "",
    receivedAmountChildSupportFrequency: "",
    incarceratedIncomeInJail: "",
    incarceratedIncomeAmount: "",
    unemploymentOrWorkersCompensation: "",
    unemployentOrWorkersCompAmount: "",
    otherBenefits: "",
    otherBenefitsAmount: "",
    payerOfBasicLivingExpenses: "",
    disabled: "",
    disabilityType: "",
    dependentForTaxPurposes: "",
    dependentNameForTaxPurposes: "",
    otherIncomeSources: "",
    cashOwned: "",
    carMake1: "",
    carValue1: "",
    carMake2: "",
    carValue2: "",
    realEstate: "",
    realEstateEquity: "",
    otherAssets: "",
    probationPayment: "",
    probationCounty: "",
    unusualExpenses: "",
    unusualExpensesAmount: "",
    additionalNotes: "",
    fullName: "",
    signature: "",
};
//     applicationDate: new Date(Date.now()).toLocaleDateString(),
//     arrestDate: "Yes",
//     offenseDate: "Yes",
//     caseNumber: "Yes",
//     courtDate: "Yes",
//     SID: "Yes",
//     judge: "Yes",
//     attorney: "Yes",
//     lastName: "Yes",
//     firstName: "Yes",
//     middleName: "Yes",
//     charge1: "Yes",
//     warrant1: "Yes",
//     charge2: "Yes",
//     warrant2: "Yes",
//     charge3: "Yes",
//     warrant3: "Yes",
//     charge4: "Yes",
//     warrant4: "Yes",
//     charge5: "Yes",
//     warrant5: "Yes",
//     codefendants: "Yes",
//     dob: "Yes",
//     race: "Yes",
//     sex: "Yes",
//     veteran: "Yes",
//     address: "Yes",
//     city: "Yes",
//     state: "Yes",
//     zip: "Yes",
//     cellPhone: "Yes",
//     email: "Yes",
//     emergencyContactName: "Yes",
//     emergencyContactPhone: "Yes",
//     emergencyContactAddress: "Yes",
//     maritalStatus: "Yes",
//     spouseName: "Yes",
//     spouseEmployment: "Yes",
//     spouseEmploymentInformation: "Yes",
//     spouseIncome: "Yes",
//     spouseIncomeFrequency: "Yes",
//     ageOfChildren: "Yes",
//     otherDependents: "Yes",
//     employment: "Yes",
//     employerName: "Yes",
//     employerAddress: "Yes",
//     employerTelephone: "Yes",
//     jobTitle: "Yes",
//     lengthOfEmployment: "Yes",
//     mostRecentEmployment: "Yes",
//     income: "Yes",
//     incomeFrequency: "Yes",
//     courtOrderedChildSupport: "Yes",
//     courtOrderedChildSupportFrequency: "Yes",
//     receiveChildSupport: "Yes",
//     receivedAmountChildSupport: "Yes",
//     receivedAmountChildSupportFrequency: "Yes",
//     incarceratedIncomeInJail: "Yes",
//     incarceratedIncomeAmount: "Yes",
//     unemploymentOrWorkersCompensation: "Yes",
//     unemployentOrWorkersCompAmount: "Yes",
//     otherBenefits: "Yes",
//     otherBenefitsAmount: "Yes",
//     payerOfBasicLivingExpenses: "Yes",
//     disabled: "Yes",
//     disabilityType: "Yes",
//     dependentForTaxPurposes: "Yes",
//     dependentNameForTaxPurposes: "Yes",
//     otherIncomeSources: "Yes",
//     cashOwned: "Yes",
//     carMake1: "Yes",
//     carValue1: "Yes",
//     carMake2: "Yes",
//     carValue2: "Yes",
//     realEstate: "Yes",
//     realEstateEquity: "Yes",
//     otherAssets: "Yes",
//     probationPayment: "Yes",
//     probationCounty: "Yes",
//     unusualExpenses: "Yes",
//     unusualExpensesAmount: "Yes",

// };


export const fieldLabels = {
    // Section 1: Personal Information
    firstName: {
        visualName: "First Name",
        section: 1,
        subsection: 1,
        required: true

    },
    middleName: {
        visualName: "Middle Name",
        section: 1,
        subsection: 1,
    },
    lastName: {
        visualName: "Last Name",
        section: 1,
        subsection: 1,
        required: true
    },

    // Section 2: Case Information
    applicationDate: {
        visualName: "Application Date",
        section: 2,
        subsection: 1,
        required: true
    },
    arrestDate: {
        visualName: "Arrest Date",
        section: 2,
        subsection: 1,
    },
    offenseDate: {
        visualName: "Offense Date",
        section: 2,
        subsection: 1
    },
    caseNumber: {
        visualName: "Case Number",
        section: 2,
        subsection: 2,
        required: true
    },
    courtDate: {
        visualName: "Court Date",
        section: 2,
        subsection: 2
    },
    SID: {
        visualName: "SID#",
        section: 2,
        subsection: 2
    },
    judge: {
        visualName: "Judge",
        section: 2,
        subsection: 3,
        required: true
    },
    attorney: {
        visualName: "Attorney",
        section: 2,
        subsection: 3
    },

    // Section 3: Charges and Warrants
    charge1: {
        visualName: "Charge 1",
        section: 3,
        subsection: 1
    },
    warrant1: {
        visualName: "Warrant #",
        section: 3,
        subsection: 1
    },
    charge2: {
        visualName: "Charge 2",
        section: 3,
        subsection: 2
    },
    warrant2: {
        visualName: "Warrant #",
        section: 3,
        subsection: 2
    },
    charge3: {
        visualName: "Charge 3",
        section: 3,
        subsection: 3
    },
    warrant3: {
        visualName: "Warrant #",
        section: 3,
        subsection: 3
    },
    charge4: {
        visualName: "Charge 4",
        section: 3,
        subsection: 4
    },
    warrant4: {
        visualName: "Warrant #",
        section: 3,
        subsection: 4
    },
    charge5: {
        visualName: "Charge 5",
        section: 3,
        subsection: 5
    },
    warrant5: {
        visualName: "Warrant #",
        section: 3,
        subsection: 5
    },
    codefendants: {
        visualName: "Co-Defendants",
        section: 3,
        subsection: 6
    },
    dob: {
        visualName: "Date of Birth",
        section: 4,
        subsection: 1,
        required: true
    },
    race: {
        visualName: "Race",
        section: 4,
        subsection: 1,
        required: true
    },
    sex: {
        visualName: "Sex",
        section: 4,
        subsection: 1,
        required: true
    },
    preferredPronouns: {
        visualName: "Preferred Pronouns",
        section: 4,
        subsection: 1
    },
    veteran: {
        visualName: "Have you served in the military?",
        section: 4,
        subsection: 1,
        radio: true,
        options: ["Yes", "No"],
        required: true
    },
    address: {
        visualName: "Address",
        section: 4,
        subsection: 1,
        required: true,
    },
    city: {
        visualName: "City",
        section: 4,
        subsection: 1,
        required: true,
    },
    state: {
        visualName: "State",
        section: 4,
        subsection: 1,
        required: true,
    },
    zip: {
        visualName: "Zip",
        section: 4,
        subsection: 1,
        required: true,
    },
    cellPhone: {
        visualName: "Cell Phone",
        section: 4,
        subsection: 1,
        required: true,
    },
    email: {
        visualName: "E-mail",
        section: 4,
        subsection: 1,
        required: true,
    },
    emergencyContactName: {
        visualName: "Emergency Contact Name",
        section: 4,
        subsection: 1,
        required: true,
    },
    emergencyContactPhone: {
        visualName: "Emergency Contact Phone",
        section: 4,
        subsection: 1,
        required: true,
    },
    emergencyContactAddress: {
        visualName: "Emergency Contact Address",
        section: 4,
        subsection: 1,
        required: true,
    },
    maritalStatus: {
        visualName: "Marital Status",
        section: 5,
        subsection: 1,
        radio: true,
        options: ["Single", "Divorced", "Separated", "Married", "Living with the parent of your children"],
        required: true,
    },
    spouseName: {
        visualName: "Spouse Name",
        section: 5,
        subsection: 1,
        dependsOn: "maritalStatus",
        dependsOnRequired: ["Married", "Living with the parent of your children", "Separated"],
    },
    spouseEmployment: {
        visualName: "Spouse Employment",
        section: 5,
        subsection: 1,
        radio: true,
        options: ["Yes", "No"],
        dependsOn: "maritalStatus",
        dependsOnRequired: ["Married", "Living with the parent of your children", "Separated"],
    },
    spouseEmploymentInformation: {
        visualName: "Spouse Employment Location",
        section: 5,
        subsection: 1,
        dependsOn: "maritalStatus",
        dependsOnRequired: ["Married", "Living with the parent of your children", "Separated"],
    },
    spouseIncome: {
        visualName: "Spouse Income",
        section: 5,
        subsection: 1,
        dependsOn: "maritalStatus",
        dependsOnRequired: ["Married", "Living with the parent of your children", "Separated"],
    },
    spouseIncomeFrequency: {
        visualName: "Spouse Income Frequency",
        section: 5,
        subsection: 1,
        radio: true,
        options: ["Week", "Two Weeks", "Month", "Year"],
        dependsOn: "maritalStatus",
        dependsOnRequired: ["Married", "Living with the parent of your children", "Separated"],
    },
    ageOfChildren: {
        visualName: "Age of Children in House",
        section: 5,
        subsection: 1,
    },
    otherDependents: {
        visualName: "Other Dependents",
        section: 5,
        subsection: 1,
    },
    employment: {
        visualName: "Are you employed? (including self-employment, part-time work, or 'odd jobs'?)",
        section: 6,
        subsection: 1,
        radio: true,
        options: ["Yes", "No"],
        required: true,
    },
    employerName: {
        visualName: "Employer Name",
        section: 6,
        subsection: 1,
        dependsOn: "employment"
    },
    employerAddress: {
        visualName: "Employer Address",
        section: 6,
        subsection: 1,
        dependsOn: "employment"
    },
    employerTelephone: {
        visualName: "Employer Telephone",
        section: 6,
        subsection: 1,
        dependsOn: "employment"
    },
    jobTitle: {
        visualName: "Job Title",
        section: 6,
        subsection: 1,
        dependsOn: "employment"
    },
    lengthOfEmployment: {
        visualName: "Length of Employment",
        section: 6,
        subsection: 1,
        dependsOn: "employment"
    },
    mostRecentEmployment: {
        visualName: "If employed less than one year at this job, state the date and income of your most recent prior employment",
        section: 6,
        subsection: 1,
        dependsOn: "employment"
    },
    income: {
        visualName: "Net Income (After Taxes)",
        section: 7,
        subsection: 1
    },
    incomeFrequency: {
        visualName: "Income Frequency",
        section: 7,
        subsection: 1,
        radio: true,
        options: ["Week", "Two Weeks", "Month", "Year"]
    },
    courtOrderedChildSupport: {
        visualName: "If child support is not deducted from check, state amount of court ordered child support",
        section: 7,
        subsection: 1
    },
    courtOrderedChildSupportFrequency: {
        visualName: "Court Ordered Child Support Frequency",
        section: 7,
        subsection: 1,
        radio: true,
        options: ["Week", "Month"],
        dependsOn: "courtOrderedChildSupport"
    },
    receiveChildSupport: {
        visualName: "Do you receive child support?",
        section: 7,
        subsection: 1,
        radio: true,
        options: ["Yes", "No"],
        required: true,
    },
    receivedAmountChildSupport: {
        visualName: "Received Child Support Amount",
        section: 7,
        subsection: 1,
        dependsOn: "receiveChildSupport"
    },
    receivedAmountChildSupportFrequency: {
        visualName: "Received Child Support Amount Frequency",
        section: 7,
        subsection: 1,
        radio: true,
        options: ["Week", "Month"],
        dependsOn: "receiveChildSupport"
    },
    incarceratedIncomeInJail: {
        visualName: "If incarcerated, do you have income while in jail?",
        section: 7,
        subsection: 1,
        radio: true,
        options: ["Yes", "No"],
        required: true,

    },
    incarceratedIncomeAmount: {
        visualName: "During Incarceration Income Amount",
        section: 7,
        subsection: 1,
        dependsOn: "incarceratedIncomeInJail"
    },
    unemploymentOrWorkersCompensation: {
        visualName: "Do you receive unemployment or worker's compensation?",
        section: 7,
        subsection: 1,
        radio: true,
        options: ["Yes", "No"],
        required: true,
    },
    unemployentOrWorkersCompAmount: {
        visualName: "Unemployment or Worker's Compensation Amount",
        section: 7,
        subsection: 1,
        dependsOn: "unemploymentOrWorkersCompensation"
    },
    otherBenefits: {
        visualName: "Do you receive Military, VA, Social Security, SSI, TANF, Food Stamps, or Retirement benefits?",
        section: 7,
        subsection: 1,
        radio: true,
        options: ["Yes", "No"],
        required: true,
    },
    otherBenefitsAmount: {
        visualName: "Other Benefits Amount",
        section: 7,
        subsection: 1,
        dependsOn: "otherBenefits"
    },
    payerOfBasicLivingExpenses: {
        visualName: "Who pays your basic living expenses? (Can be yourself)",
        section: 7,
        subsection: 1,
        required: true,
    },
    disabled: {
        visualName: "Are you disabled?",
        section: 7,
        subsection: 1,
        radio: true,
        options: ["Yes", "No"],
        required: true,
    },
    disabilityType: {
        visualName: "What type of disability?",
        section: 7,
        subsection: 1,
        dependsOn: "disabled"
    },
    dependentForTaxPurposes: {
        visualName: "Does anyone claim you as a dependent for tax purposes?",
        section: 7,
        subsection: 1,
        radio: true,
        options: ["Yes", "No"],
        required: true,
    },
    dependentNameForTaxPurposes: {
        visualName: "What is your tax dependent's name?",
        section: 7,
        subsection: 1,
        dependsOn: "dependentForTaxPurposes"
    },
    otherIncomeSources: {
        visualName: "Any other sources of income/payments?",
        section: 7,
        subsection: 1
    },
    cashOwned: {
        visualName: "Cash, checking accounts, savings accounts, retirement accounts, inmate accounts value $",
        section: 8,
        subsection: 1,
        required: true,
    },
    carMake1: {
        visualName: "Year, Make, Model of Vehicle",
        section: 8,
        subsection: 1,
        required: true,
    },
    carValue1: {
        visualName: "Est. Value $",
        section: 8,
        subsection: 1
    },
    carMake2: {
        visualName: "Year, Make, Model of Vehicle #2",
        section: 8,
        subsection: 1
    },
    carValue2: {
        visualName: "Est. Value $",
        section: 8,
        subsection: 1
    },
    realEstate: {
        visualName: "Is any real estate titled in your name?",
        section: 8,
        subsection: 1,
        radio: true,
        options: ["Yes", "No"],
        required: true,
    },
    realEstateEquity: {
        visualName: "Real estate equity",
        section: 8,
        subsection: 1,
        dependsOn: "realEstate"
    },
    otherAssets: {
        visualName: "Other Assets Est. Value $",
        section: 8,
        subsection: 1
    },
    probationPayment: {
        visualName: "Court ordered probation payment",
        section: 9,
        subsection: 1
    },
    probationCounty: {
        visualName: "County of probation",
        section: 9,
        subsection: 1
    },
    unusualExpenses: {
        visualName: "Unusual expenses",
        section: 10,
        subsection: 1
    },
    unusualExpensesAmount: {
        visualName: "Unusual expenses amount",
        section: 10,
        subsection: 1
    },
    additionalNotes: {
        visualName: "Any additional notes you would like to add",
        section: 11,
        subsection: 1,
    },
    fullName: {
        visualName: "Full Name",
        section: 11,
        subsection: 2,
    },
    signature: {
        visualName: "Signature",
        section: 11,
        required: true
    }
};

export const sectionComponents = [
    {
        title: "Name",
        component: buildSection1,
        sectionNumber: 1,
    },
    {
        title: "Case Information",
        component: buildSection2,
        sectionNumber: 2,
    },
    {
        title: "Charges",
        component: buildSection3,
        sectionNumber: 3,
    },
    {
        title: "Demographic Information",
        component: buildSection4,
        sectionNumber: 4,
    },
    {
        title: "Marital Status",
        component: buildSection5,
        sectionNumber: 5,
    },
    {
        title: "Employment",
        component: buildSection6,
        sectionNumber: 6,
    },
    {
        title: "Income",
        component: buildSection7,
        sectionNumber: 7,
    },
    {
        title: "Things You Own",
        component: buildSection8,
        sectionNumber: 8,
    },
    {
        title: "Probation",
        component: buildSection9,
        sectionNumber: 9,
    },
    {
        title: "Unusual Expenses",
        component: buildSection10,
        sectionNumber: 10,
    },
    {
        title: "Additional Notes",
        component: buildSection11,
        sectionNumber: 11,
    },
];

function buildSection1(values, handleChange, handleBlur, errors, touched, isSubmitting) {
    return (<Grid container spacing={2} mb={2}>
        {Object.keys(fieldLabels)
            .filter((key) => fieldLabels[key].section === 1)
            .map((key) => (
                <Grid item xs='12' sm='4'>
                    <Field
                        as={TextField}
                        fullWidth
                        variant="outlined"
                        label={fieldLabels[key].visualName || key}
                        name={key}
                        key={key}
                        type="text"
                        error={touched[key] && Boolean(errors[key])}
                        helperText={touched[key] && errors[key]}
                        disabled={isSubmitting}
                    />
                </Grid>
            ))}
    </Grid>);
}

function buildSection2(values, handleChange, handleBlur, errors, touched, isSubmitting) {
    return (<Grid container spacing={2} mb={2}>
        {Object.keys(fieldLabels)
            .filter((key) => fieldLabels[key].section === 2)
            .map((key) => (
                < Grid item xs={12} sm={6} key={key} >
                    <Field
                        as={TextField}
                        fullWidth
                        variant="outlined"
                        label={fieldLabels[key].visualName || key}
                        name={key}
                        key={key}
                        type="text"
                        error={touched[key] && Boolean(errors[key])}
                        helperText={touched[key] && errors[key]}
                        disabled={isSubmitting}
                    />
                </Grid>
            )
            )
        }
    </Grid >)
}

function buildSection3(values, handleChange, handleBlur, errors, touched, isSubmitting) {
    return (<Grid container spacing={2} mb={2}>
        {Object.keys(fieldLabels)
            .filter((key) => fieldLabels[key].section === 3 && fieldLabels[key].subsection != 6)
            .map((key) => (
                < Grid item xs={12} sm={6} key={key} >
                    <Field
                        as={TextField}
                        fullWidth
                        variant="outlined"
                        label={fieldLabels[key].visualName || key}
                        name={key}
                        key={key}
                        type="text"
                        error={touched[key] && Boolean(errors[key])}
                        helperText={touched[key] && errors[key]}
                        disabled={isSubmitting}
                    />
                </Grid>
            ))
        }
        <Grid item xs={12} sm={12}>
            <Field
                as={TextField}
                fullWidth
                variant="outlined"
                label={fieldLabels["codefendants"].visualName || "Co-Defendants"}
                name="codefendants"
                key="codefendants"
                type="text"
                error={touched["codefendants"] && Boolean(errors["codefendants"])}
                helperText={touched["codefendants"] && errors["codefendants"]}
                disabled={isSubmitting}
            />
        </Grid>
    </Grid >)
}

function buildSection4(values, handleChange, handleBlur, errors, touched, isSubmitting) {
    return (
        <Grid container spacing={2} mb={2}>
            {Object.keys(fieldLabels)
                .filter(key => fieldLabels[key].section === 4)
                .map(key => {
                    return (
                        <Grid item xs={12} sm={4} key={key}>
                            {fieldLabels[key].radio ? (
                                <Field name={key}>
                                    {({ field, meta }) => (
                                        <FormControl
                                            component="fieldset"
                                            disabled={isSubmitting}
                                            error={meta.touched && Boolean(meta.error)}
                                        >
                                            <FormLabel component="legend">
                                                {fieldLabels[key].visualName || key}
                                            </FormLabel>
                                            <RadioGroup {...field} onChange={handleChange} row>
                                                {fieldLabels[key].options.map(option => (
                                                    <FormControlLabel
                                                        key={option}
                                                        value={option}
                                                        control={<Radio />}
                                                        label={option}
                                                    />
                                                ))}
                                            </RadioGroup>
                                            {meta.touched && meta.error && (
                                                <FormHelperText>{meta.error}</FormHelperText>
                                            )}
                                        </FormControl>
                                    )}
                                </Field>
                            ) : (key === "dob" ?
                                <Field
                                    as={TextField}
                                    fullWidth
                                    type="date"
                                    variant="outlined"
                                    label={fieldLabels[key].visualName || key}
                                    name={key}
                                    error={touched[key] && Boolean(errors[key])}
                                    helperText={touched[key] && errors[key]}
                                    disabled={isSubmitting}
                                    InputLabelProps={{ shrink: true }}
                                /> : <Field
                                    as={TextField}
                                    fullWidth
                                    variant="outlined"
                                    label={fieldLabels[key].visualName || key}
                                    name={key}
                                    type="text"
                                    error={touched[key] && Boolean(errors[key])}
                                    helperText={touched[key] && errors[key]}
                                    disabled={isSubmitting}
                                />

                            )}
                        </Grid>
                    );
                })}
        </Grid>
    );
}

function buildSection5(values, handleChange, handleBlur, errors, touched, isSubmitting) {
    return (<Grid container spacing={2} mb={2}>
        {Object.keys(fieldLabels)
            .filter((key) => fieldLabels[key].section === 5)
            .map((key) => {
                if (fieldLabels[key].dependsOn && !fieldLabels[key].dependsOnRequired.includes(values[fieldLabels[key].dependsOn])) {
                    return null;
                }
                if (fieldLabels[key].radio) {
                    return (
                        < Grid item xs={12} sm={6} key={key} >
                            < Field key={key} name={key} >
                                {({ field, meta }) => {
                                    const showError = meta.touched && Boolean(meta.error);
                                    return (
                                        <FormControl component="fieldset" error={showError} disabled={isSubmitting}>
                                            <FormLabel component="legend">
                                                {fieldLabels[key].visualName || key}
                                            </FormLabel>
                                            <RadioGroup {...field} error={meta.touched && Boolean(meta.error)} onChange={handleChange} row>
                                                {
                                                    fieldLabels[key].options.map((option) => (
                                                        <FormControlLabel
                                                            value={option}
                                                            control={<Radio />}
                                                            label={option}
                                                        />
                                                    ))
                                                }
                                            </RadioGroup>
                                        </FormControl>
                                    )
                                }}
                            </Field> </Grid>);


                }
                else {
                    return (
                        < Grid item xs={12} sm={6} key={key} >
                            <Field
                                as={TextField}
                                fullWidth
                                variant="outlined"
                                label={fieldLabels[key].visualName || key}
                                name={key}
                                key={key}
                                type="text"
                                error={touched[key] && Boolean(errors[key])}
                                helperText={touched[key] && errors[key]}
                                disabled={isSubmitting}
                            />
                        </Grid >
                    );
                }

            })}
    </Grid >);
}

function buildSection6(values, handleChange, handleBlur, errors, touched, isSubmitting) {
    return (<Grid container spacing={2} mb={2}>
        {Object.keys(fieldLabels)
            .filter((key) => fieldLabels[key].section === 6)
            .map((key) => {
                if (fieldLabels[key].dependsOn && values[fieldLabels[key].dependsOn] !== "Yes") {
                    return null;
                }
                return (
                    < Grid item xs={12} sm={12} key={key} >
                        {
                            fieldLabels[key].radio === true ? (
                                < Field key={key} name={key}>
                                    {({ field, meta }) => (
                                        <FormControl component="fieldset" error={meta.touched && Boolean(meta.error)} disabled={isSubmitting}>
                                            <FormLabel component="legend">
                                                {fieldLabels[key].visualName || key}
                                            </FormLabel>
                                            <RadioGroup {...field} onChange={handleChange} row>
                                                {
                                                    fieldLabels[key].options.map((option) => (
                                                        <FormControlLabel
                                                            value={option}
                                                            control={<Radio />}
                                                            label={option}
                                                        />
                                                    ))
                                                }
                                            </RadioGroup>
                                        </FormControl>
                                    )}
                                </Field>
                            ) : (
                                <Field
                                    as={TextField}
                                    fullWidth
                                    variant="outlined"
                                    label={fieldLabels[key].visualName || key}
                                    name={key}
                                    key={key}
                                    type="text"
                                    error={touched[key] && Boolean(errors[key])}
                                    helperText={touched[key] && errors[key]}
                                    disabled={isSubmitting}
                                />
                            )
                        }
                    </Grid >)
            })}
    </Grid >)
}

function buildSection7(values, handleChange, handleBlur, errors, touched, isSubmitting) {
    return (<Grid container spacing={2} mb={2}>
        {Object.keys(fieldLabels)
            .filter((key) => fieldLabels[key].section === 7)
            .map((key) => {
                if (fieldLabels[key].dependsOn) {
                    if (fieldLabels[fieldLabels[key].dependsOn].radio &&
                        values[fieldLabels[key].dependsOn] !== "Yes") {
                        return null;
                    }
                    else if (values[fieldLabels[key].dependsOn] === "") {
                        return null;
                    }
                }
                return (
                    < Grid item xs={12} sm={12} key={key} >
                        {
                            fieldLabels[key].radio === true ? (
                                < Field key={key} name={key} >
                                    {({ field, meta }) => (
                                        <FormControl component="fieldset" error={meta.touched && Boolean(meta.error)} disabled={isSubmitting}>
                                            <FormLabel component="legend">
                                                {fieldLabels[key].visualName || key}
                                            </FormLabel>
                                            <RadioGroup {...field} onChange={handleChange} row>
                                                {
                                                    fieldLabels[key].options.map((option) => (
                                                        <FormControlLabel
                                                            value={option}
                                                            control={<Radio />}
                                                            label={option}
                                                        />
                                                    ))
                                                }
                                            </RadioGroup>
                                        </FormControl>
                                    )}
                                </Field>
                            ) : (
                                <Field
                                    as={TextField}
                                    fullWidth
                                    variant="outlined"
                                    label={fieldLabels[key].visualName || key}
                                    name={key}
                                    key={key}
                                    type="text"
                                    error={touched[key] && Boolean(errors[key])}
                                    helperText={touched[key] && errors[key]}
                                    disabled={isSubmitting}
                                />
                            )
                        }
                    </Grid >
                )
            })}
    </Grid >)
}

function buildSection8(values, handleChange, handleBlur, errors, touched, isSubmitting) {
    return (<Grid container spacing={2} mb={2}>
        {Object.keys(fieldLabels)
            .filter((key) => fieldLabels[key].section === 8)
            .map((key) => {
                if (fieldLabels[key].dependsOn && values[fieldLabels[key].dependsOn] !== "Yes") {
                    return null;
                }
                return (
                    < Grid item xs={12} sm={12} key={key} >
                        {
                            fieldLabels[key].radio === true ? (
                                < Field key={key} name={key} >
                                    {({ field, meta }) => (
                                        <FormControl component="fieldset" error={meta.touched && Boolean(meta.error)}>
                                            <FormLabel component="legend">
                                                {fieldLabels[key].visualName || key}
                                            </FormLabel>
                                            <RadioGroup {...field} onChange={handleChange} row>
                                                {
                                                    fieldLabels[key].options.map((option) => (
                                                        <FormControlLabel
                                                            value={option}
                                                            control={<Radio />}
                                                            label={option}
                                                        />
                                                    ))
                                                }
                                            </RadioGroup>
                                        </FormControl>
                                    )}
                                </Field>
                            ) : (
                                <Field
                                    as={TextField}
                                    fullWidth
                                    variant="outlined"
                                    label={fieldLabels[key].visualName || key}
                                    name={key}
                                    key={key}
                                    type="text"
                                    error={touched[key] && Boolean(errors[key])}
                                    helperText={touched[key] && errors[key]}
                                    disabled={isSubmitting}
                                />
                            )
                        }
                    </Grid >
                )
            })}
    </Grid >)
}

function buildSection9(values, handleChange, handleBlur, errors, touched, isSubmitting) {
    return (<Grid container spacing={2} mb={2}>
        {Object.keys(fieldLabels)
            .filter((key) => fieldLabels[key].section === 9)
            .map((key) => {
                if (fieldLabels[key].dependsOn && values[fieldLabels[key].dependsOn] !== "Yes") {
                    return null;
                }
                return (
                    < Grid item xs={12} sm={6} key={key} >
                        {
                            fieldLabels[key].radio === true ? (
                                < Field key={key} >
                                    {({ field, meta }) => (
                                        <FormControl component="fieldset" error={meta.touched && Boolean(meta.error)}>
                                            <FormLabel component="legend">
                                                {fieldLabels[key].visualName || key}
                                            </FormLabel>
                                            <RadioGroup {...field} onChange={handleChange} row>
                                                {
                                                    fieldLabels[key].options.map((option) => (
                                                        <FormControlLabel
                                                            value={option}
                                                            control={<Radio />}
                                                            label={option}
                                                        />
                                                    ))
                                                }
                                            </RadioGroup>
                                            {meta.touched && meta.error && (
                                                <FormHelperText>{meta.error}</FormHelperText>
                                            )}
                                        </FormControl>
                                    )}
                                </Field>
                            ) : (
                                <Field
                                    as={TextField}
                                    fullWidth
                                    variant="outlined"
                                    label={fieldLabels[key].visualName || key}
                                    name={key}
                                    key={key}
                                    type="text"
                                    error={touched[key] && Boolean(errors[key])}
                                    helperText={touched[key] && errors[key]}
                                    disabled={isSubmitting}
                                />
                            )
                        }
                    </Grid >
                )
            })}
    </Grid >)
}

function buildSection10(values, handleChange, handleBlur, errors, touched, isSubmitting) {
    return (<Grid container spacing={2} mb={2}>
        {Object.keys(fieldLabels)
            .filter((key) => fieldLabels[key].section === 10)
            .map((key) => (
                <Grid item xs='12' sm='6'>
                    <Field
                        as={TextField}
                        fullWidth
                        variant="outlined"
                        label={fieldLabels[key].visualName || key}
                        name={key}
                        key={key}
                        type="text"
                        error={touched[key] && Boolean(errors[key])}
                        helperText={touched[key] && errors[key]}
                        disabled={isSubmitting}
                    />
                </Grid>
            ))}
    </Grid>);
}

function buildSection11(values, handleChange, handleBlur, errors, touched, isSubmitting) {
    return <Box mt={3} display="flex" flexDirection="column" alignItems="center">
        {Object.keys(fieldLabels)
            .filter((key) => key === "additionalNotes")
            .map((key) => (
                <Field
                    as={TextField}
                    fullWidth
                    variant="outlined"
                    label={fieldLabels[key].visualName || key}
                    multiline
                    rows={2}
                    name={key}
                    key={key}
                    type="text"
                    error={touched[key] && Boolean(errors[key])}
                    helperText={touched[key] && errors[key]}
                    disabled={isSubmitting}
                />
            ))}

        <Divider style={{ margin: "25px 0" }} />

        <Typography
            variant="body2"
            align="left"
            gutterBottom
            sx={{ fontSize: '12px' }}
        >
            {legalDisclaimer1}
        </Typography>
        <Typography
            variant="body2"
            align="left"
            gutterBottom
            sx={{ fontSize: '12px' }}
        >
            {legalDisclaimer2}
        </Typography>
        <Typography
            variant="body2"
            align="left"
            gutterBottom
            sx={{ fontSize: '14px', fontWeight: 'bold' }}
        >
            {legalDisclaimer3}
        </Typography>

        <Divider style={{ margin: "25px 0" }} />

        {Object.keys(fieldLabels)
            .filter((key) => key === "fullName")
            .map((key) => (
                <Field
                    as={TextField}
                    fullWidth
                    variant="outlined"
                    label={fieldLabels[key].visualName || key}
                    name={key}
                    key={key}
                    type="text"
                    error={touched[key] && Boolean(errors[key])}
                    helperText={touched[key] && errors[key]}
                    disabled={isSubmitting}
                />
            ))}
        <Box mt={4} width="100%" display="flex" flexDirection="column" alignItems="center">
            <Typography variant="subtitle1">Your Signature</Typography>
            <Field name="signature">
                {({ field, form }) => (
                    <div>
                        {/* 2) Inside your SignatureField, call setFieldTouched */}
                        <SignatureField
                            name="signature"
                            {...field}
                            setFieldValue={form.setFieldValue}
                            setFieldTouched={form.setFieldTouched}
                        />
                    </div>
                )}
            </Field>
        </Box>

    </Box>
}

const legalDisclaimer1 = `
        NOTICE OF APPLICATION FEE AND ATTORNEY FEE: Georgia law requires every person who applies for legal defense
        services under Chapter 12 of Title 17 to pay the Public Defender Office (the entity providing the services) a single fee of $50 for
        the application for, receipt of, or application for and receipt of such services (O.C.G.A. Section 15-21A 6(b)). However, this
        application fee may not be imposed if the payment of the fee is waived by the court in which you are appearing. The court shall
        waive this fee if it finds that you are unable to pay the fee or that hardship will result if the fee is charged. (O.C.G.A. Section 15-
        21A 6(b)). Attorney fees for court- appointed representation may also be imposed by the court at sentencing.
        VERIFICATION AND RELEASE: BY MY SIGNATURE BELOW, I SWEAR UNDER PENALTY OF PERJURY THAT
        THE INFORMATION CONTAINED HEREIN IS TRUE AND BASED UPON MY PERSONAL KNOWLEDGE, AND I
        REQUEST THAT THE CIRCUIT PUBLIC DEFENDER’S OFFICE (CPD) REPRESENT ME, OR THE MINOR CHILD
        OR TAX-DEPENDENT PERSON I AM PARENT OR GUARDIAN OF, IN THE ABOVE STYLED CASE(S). FURTHER,
        I AGREE TO IMMEDIATELY REPORT ANY CHANGE IN MY FINANCIAL SITUATION TO THE CPD OR TO THE
        COURT. I HEREBY AUTHORIZE ANY PERSON OR AGENCY REQUESTED BY THE CPD OR ANY OF ITS
        EMPLOYEES TO RELEASE TO THE CPD ANY INFORMATION REQUESTED TO ASSIST IN CONSIDERATION OF
        MY APPLICATION. INFORMATION MAY INCLUDE INFORMATION ABOUT HOUSEHOLD INCOME,
        EMPLOYMENT, EXPENSES, LIABILITIES, OR OTHER INFORMATION REQUESTED TO ASSESS THE
        APPLICATION. I ALSO VERIFY THAT I HAVE READ THE NOTICE OF APPLICATION FEE. I UNDERSTAND
        THAT IF I HAVE MADE ANY FALSE STATEMENTS THAT I MAY BE CHARGED WITH A FELONY WHICH
        CARRIES A PENALTY OF FROM ONE TO FIVE YEARS to wit: § 16-10-20.
        `;

const legalDisclaimer2 = `
        False statements and writings; concealment
        of facts: A person who knowingly and willfully falsifies, conceals, or covers up by any trick, scheme, or device a material
        fact; makes a false, fictitious, or fraudulent statement or representation; or makes or uses any false writing or document,
        knowing the same to contain any false, fictitious, or fraudulent statement or entry, in any matter within the jurisdiction of
        any department or agency of state government or of the government of any county, city, or other political subdivision of
        this state shall, upon conviction thereof, be punished by a fine of not more than $1,000.00 or by imprisonment for not less
        than one nor more than five years, or both.
        `;

const legalDisclaimer3 = `
        I HEREBY SWEAR OR AFFIRM THAT ALL OF THE ABOVE INFORMATION IS TRUE AND CORRECT TO THE BEST OF MY KNOWLEDGE.
        `;